/* eslint-disable no-useless-escape */
// import inputMentionsStyles from './input-mentions-styles';
// import { useMemo } from 'react';

import { makeStyles, tokens } from '@fluentui/react-components';
import { SmartVariables } from '../../../components/shared/smart-variables';

const smartVariables = [
	'{{workItem.id}}',
	'{{workItem.title}}',
	'{{workItem.type}}',
	'{{workItem.state}}',
	'{{workItem.description}}',
	'{{workItem.url}}',
	'{{project.id}}',
	'{{project.name}}',
	'{{workItem.assignedTo.id}}',
	'{{workItem.assignedTo.displayName}}',
	'{{workItem.createdBy.id}}',
	'{{workItem.createdBy.displayName}}',
	'{{workItem.userWhoTriggered}}',
	'{{parent.workItem.id}}',
	'{{parent.workItem.title}}',
	'{{parent.workItem.type}}',
	'{{parent.workItem.state}}',
	'{{parent.workItem.description}}',
	'{{parent.workItem.url}}',
	'{{parent.workItem.assignedTo.id}}',
	'{{parent.workItem.assignedTo.displayName}}',
	'{{parent.workItem.createdBy.id}}',
	'{{parent.workItem.createdBy.displayName}}',
];

interface Props {
	placeholder: string;
	value: string;
	onChange(value: string): void;
	messageError?: string | null;
}

export const TextAreaWithHighLights = (props: Props) => {
	const classes = useStyles();

	return (
		<div
			className={classes.mentionsRoot}
		>
			<SmartVariables
				value={props.value}
				onChange={props.onChange}
				options={smartVariables.map(item => ({ label: item, value: item }))}
				placeholder={props.placeholder}
			/>
		</div>
	);
};

export const TextAreaHelperText = () => {
	const classes = useStyles();
	return (
		<div className={classes.helperText}>
			<span>{'Type "{{" to view smart variables related to work item fields.'}</span>
		</div>
	);
};

export const useStyles = makeStyles({
	root: {},
	helperText: {
		boxSizing: 'border-box',
		borderRadius: '4px',
	},
	mentionsRoot: {
		borderRadius: '40px',
	},
	validationMessage: {
		color: tokens.colorPaletteRedForeground1
	}
});
